import { Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function HoldingPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-indigo-900 flex items-center justify-center px-6">
      <div className="max-w-2xl mx-auto text-center">
        {/* Logo */}
        <div className="mb-8 flex justify-center">
          <img 
            src="/vo-connect-logo.png" 
            alt="VO-Connect" 
            className="h-24 md:h-32 drop-shadow-2xl"
          />
        </div>

        {/* Main Heading */}
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
          Coming Soon
        </h1>

        {/* Tagline */}
        <p className="text-xl md:text-2xl text-blue-200 mb-4">
          Global Voice Production, Streamlined.
        </p>

        {/* Description */}
        <p className="text-lg text-slate-300 mb-12 max-w-xl mx-auto">
          We're building the world's first centralized platform connecting voice production studios 
          and post-production coordinators. Join the revolution in professional voice recording.
        </p>

        {/* Features */}
        <div className="grid md:grid-cols-3 gap-6 mb-12 max-w-3xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <div className="text-3xl mb-3">🎙️</div>
            <h3 className="text-white font-semibold mb-2">For Studios</h3>
            <p className="text-slate-300 text-sm">
              Manage your availability, showcase your facilities, and connect with top productions globally
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <div className="text-3xl mb-3">📅</div>
            <h3 className="text-white font-semibold mb-2">Real-Time Booking</h3>
            <p className="text-slate-300 text-sm">
              See studio availability instantly and book sessions with confidence
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <div className="text-3xl mb-3">🌍</div>
            <h3 className="text-white font-semibold mb-3">Global Network</h3>
            <p className="text-slate-300 text-sm">
              Access professional voice studios across ADR, Gaming, Audiobooks, Animation, and Commercial
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 border border-white/20 max-w-md mx-auto">
          <h3 className="text-white font-semibold mb-4">Get Early Access</h3>
          <p className="text-slate-300 text-sm mb-6">
            Be among the first to experience the future of voice production booking
          </p>
          <Button 
            size="lg"
            className="bg-blue-600 hover:bg-blue-700 text-white w-full"
            onClick={() => window.location.href = 'mailto:support@vo-connect.com?subject=Early Access Request'}
          >
            <Mail className="w-4 h-4 mr-2" />
            Request Early Access
          </Button>
        </div>

        {/* Footer */}
        <div className="mt-16 text-slate-400 text-sm">
          <p>© 2026 VO-Connect. All rights reserved.</p>
          <p className="mt-2">
            Questions? Contact us at{' '}
            <a href="mailto:support@vo-connect.com" className="text-blue-300 hover:text-blue-200 underline">
              support@vo-connect.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
